export default "__VITE_ASSET__DwR5T1P2__"